module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "expense-table-component"
  }, [_c('b-card', {
    staticClass: "formCard"
  }, [_c('b-card-text', [_c('div', {
    staticClass: "d-flex justify-content-between align-items-center mb-3"
  }, [_c('h5', {
    staticClass: "mb-0"
  }, [_c('b-badge', {
    attrs: {
      "variant": "info"
    }
  }, [_vm._v("Nature Of Expense Charges Details")])], 1), _vm._v(" "), _c('div', {
    staticClass: "d-flex align-items-center"
  }, [_c('model-list-select', {
    ref: "natureExpenseSelect",
    staticClass: "expense-select-dropdown",
    attrs: {
      "list": _vm.natureOfExpenseOptions,
      "option-value": "nature_name",
      "option-text": "nature_name",
      "placeholder": "Select Nature of Expense"
    },
    model: {
      value: (_vm.customExpense.nature_name),
      callback: function($$v) {
        _vm.$set(_vm.customExpense, "nature_name", $$v)
      },
      expression: "customExpense.nature_name"
    }
  }), _vm._v(" "), _c('b-button', {
    attrs: {
      "variant": "primary",
      "size": "sm",
      "disabled": _vm.isLoading || !_vm.customExpense.nature_name.trim()
    },
    on: {
      "click": _vm.addCustomExpense
    }
  }, [_c('md-icon', [_vm._v("add")]), _vm._v(" Add\n          ")], 1)], 1)]), _vm._v(" "), _c('div', {
    staticClass: "table-responsive"
  }, [(_vm.natureOfExpense && _vm.natureOfExpense.length > 0) ? _c('table', {
    staticClass: "table table-sm table-bordered table-striped expense-table"
  }, [_c('thead', {
    staticClass: "thead-light"
  }, [_c('tr', [_c('th', {
    staticStyle: {
      "min-width": "10px"
    }
  }, [_vm._v("SN")]), _vm._v(" "), _c('th', {
    staticStyle: {
      "min-width": "200px"
    }
  }, [_vm._v("Nature of Expense")]), _vm._v(" "), _c('th', {
    staticStyle: {
      "min-width": "120px"
    }
  }, [_vm._v("Expense Incurred")]), _vm._v(" "), _c('th', {
    staticStyle: {
      "min-width": "160px"
    }
  }, [_vm._v("Upload Invoice")]), _vm._v(" "), _c('th', {
    staticStyle: {
      "min-width": "130px"
    }
  }, [_vm._v("Amount to Pay")]), _vm._v(" "), _c('th', {
    staticStyle: {
      "min-width": "120px"
    }
  }, [_vm._v("Bill to Shipper")]), _vm._v(" "), _c('th', {
    staticStyle: {
      "min-width": "130px"
    }
  }, [_vm._v("Amount to Bill")]), _vm._v(" "), _c('th', {
    staticStyle: {
      "min-width": "140px"
    }
  }, [_vm._v("Bill to Type")]), _vm._v(" "), _c('th', {
    staticStyle: {
      "min-width": "80px"
    }
  }, [_vm._v("Actions")])])]), _vm._v(" "), _c('tbody', _vm._l((_vm.natureOfExpense), function(item, index) {
    return _c('tr', {
      key: ("expense-row-" + index),
      staticClass: "expense-row"
    }, [_c('td', {
      staticClass: "text-center"
    }, [_vm._v(_vm._s(index + 1))]), _vm._v(" "), _c('td', [_c('div', [_vm._v("\n                  " + _vm._s(item.nature_name) + "\n                  "), (item.isCustom) ? _c('b-badge', {
      staticClass: "ml-1",
      attrs: {
        "variant": "info",
        "size": "sm"
      }
    }, [_vm._v("Custom")]) : _vm._e()], 1)]), _vm._v(" "), _c('td', [(item.expenseIncurred) ? _c('div', [_c('b-form-radio-group', {
      attrs: {
        "options": _vm.yesNoOptions,
        "name": 'expenseIncurred_' + index,
        "buttons": "",
        "button-variant": "outline-primary",
        "size": "sm"
      },
      on: {
        "input": function($event) {
          _vm.onExpenseIncurredChange(index, $event)
        }
      },
      model: {
        value: (item.expenseIncurred),
        callback: function($$v) {
          _vm.$set(item, "expenseIncurred", $$v)
        },
        expression: "item.expenseIncurred"
      }
    })], 1) : _c('div', [_c('small', {
      staticClass: "text-muted"
    }, [_vm._v("Select Yes/No")]), _vm._v(" "), _c('b-form-radio-group', {
      attrs: {
        "options": _vm.yesNoOptions,
        "name": 'expenseIncurred_' + index,
        "buttons": "",
        "button-variant": "outline-primary",
        "size": "sm"
      },
      on: {
        "input": function($event) {
          _vm.onExpenseIncurredChange(index, $event)
        }
      },
      model: {
        value: (item.expenseIncurred),
        callback: function($$v) {
          _vm.$set(item, "expenseIncurred", $$v)
        },
        expression: "item.expenseIncurred"
      }
    })], 1), _vm._v(" "), (_vm.getFieldValidationMessage(index, 'expenseIncurred')) ? _c('div', {
      staticClass: "text-danger small mt-1"
    }, [_c('i', {
      staticClass: "fa fa-exclamation-triangle mr-1"
    }), _vm._v("\n                  " + _vm._s(_vm.getFieldValidationMessage(index, 'expenseIncurred')) + "\n                ")]) : _vm._e()]), _vm._v(" "), _c('td', [(item.expenseIncurred === 'Yes') ? _c('div', [(!item.invoiceFile) ? _c('div', [_c('SingleUpload', {
      attrs: {
        "index": index,
        "assign_no": _vm.jobNo || item.job_type || '',
        "documentName": 'Expense_' + (item.nature_name || 'Unknown'),
        "fileAllModuleId": _vm.allModuleId || ''
      },
      on: {
        "fileuploaded": _vm.handleFileUploaded,
        "fileuploadedindex": _vm.handleFileUploadedIndex
      }
    })], 1) : _vm._e(), _vm._v(" "), (item.invoiceFile) ? _c('div', {
      staticClass: "mt-1"
    }, [_c('a', {
      staticClass: "text-primary mr-2 small",
      staticStyle: {
        "text-decoration": "underline",
        "font-size": "12px"
      },
      attrs: {
        "href": "#"
      },
      on: {
        "click": function($event) {
          $event.preventDefault();
          _vm.viewDocument(_vm.getFileName(item.invoiceFile), _vm.allModuleId, _vm.jobNo || item.job_type)
        }
      }
    }, [_c('i', {
      staticClass: "fa fa-eye mr-1"
    }), _vm._v("View\n                    ")]), _vm._v(" "), _c('a', {
      staticClass: "text-success small",
      staticStyle: {
        "text-decoration": "underline",
        "font-size": "12px"
      },
      attrs: {
        "href": "#"
      },
      on: {
        "click": function($event) {
          $event.preventDefault();
          _vm.downloadDocument(_vm.getFileName(item.invoiceFile), _vm.allModuleId, _vm.jobNo || item.job_type)
        }
      }
    }, [_c('i', {
      staticClass: "fa fa-download mr-1"
    }), _vm._v("Download\n                    ")])]) : _vm._e(), _vm._v(" "), (_vm.getFieldValidationMessage(index, 'invoiceFile')) ? _c('div', {
      staticClass: "text-danger small mt-1"
    }, [_c('i', {
      staticClass: "fa fa-exclamation-triangle mr-1"
    }), _vm._v("\n                    " + _vm._s(_vm.getFieldValidationMessage(index, 'invoiceFile')) + "\n                  ")]) : _vm._e()]) : _c('span', {
      staticClass: "text-muted"
    }, [_vm._v("-")])]), _vm._v(" "), _c('td', [_c('div', [(item.expenseIncurred === 'Yes') ? _c('b-form-input', {
      staticStyle: {
        "min-width": "120px"
      },
      attrs: {
        "type": "number",
        "step": "0.01",
        "placeholder": "Amount",
        "size": "sm"
      },
      on: {
        "input": function($event) {
          _vm.clearValidationMessage(index, 'amountToBePaid')
        }
      },
      model: {
        value: (item.amountToBePaid),
        callback: function($$v) {
          _vm.$set(item, "amountToBePaid", $$v)
        },
        expression: "item.amountToBePaid"
      }
    }) : _c('span', {
      staticClass: "text-muted"
    }, [_vm._v("-")]), _vm._v(" "), (_vm.getFieldValidationMessage(index, 'amountToBePaid')) ? _c('div', {
      staticClass: "text-danger small mt-1"
    }, [_c('i', {
      staticClass: "fa fa-exclamation-triangle mr-1"
    }), _vm._v("\n                    " + _vm._s(_vm.getFieldValidationMessage(index, 'amountToBePaid')) + "\n                  ")]) : _vm._e()], 1)]), _vm._v(" "), _c('td', [(item.billToShipper) ? _c('div', [_c('b-form-radio-group', {
      attrs: {
        "options": _vm.yesNoOptions,
        "name": 'billToShipper_' + index,
        "buttons": "",
        "button-variant": "outline-success",
        "size": "sm"
      },
      on: {
        "input": function($event) {
          _vm.onBillToShipperChange(index, $event)
        }
      },
      model: {
        value: (item.billToShipper),
        callback: function($$v) {
          _vm.$set(item, "billToShipper", $$v)
        },
        expression: "item.billToShipper"
      }
    })], 1) : _c('div', [_c('small', {
      staticClass: "text-muted"
    }, [_vm._v("Select Yes/No")]), _vm._v(" "), _c('b-form-radio-group', {
      attrs: {
        "options": _vm.yesNoOptions,
        "name": 'billToShipper_' + index,
        "buttons": "",
        "button-variant": "outline-success",
        "size": "sm"
      },
      on: {
        "input": function($event) {
          _vm.onBillToShipperChange(index, $event)
        }
      },
      model: {
        value: (item.billToShipper),
        callback: function($$v) {
          _vm.$set(item, "billToShipper", $$v)
        },
        expression: "item.billToShipper"
      }
    })], 1), _vm._v(" "), (_vm.getFieldValidationMessage(index, 'billToShipper')) ? _c('div', {
      staticClass: "text-danger small mt-1"
    }, [_c('i', {
      staticClass: "fa fa-exclamation-triangle mr-1"
    }), _vm._v("\n                  " + _vm._s(_vm.getFieldValidationMessage(index, 'billToShipper')) + "\n                ")]) : _vm._e()]), _vm._v(" "), _c('td', [_c('div', [(item.billToShipper === 'Yes') ? _c('b-form-input', {
      staticStyle: {
        "min-width": "120px"
      },
      attrs: {
        "type": "number",
        "step": "0.01",
        "placeholder": "Amount",
        "size": "sm"
      },
      on: {
        "input": function($event) {
          _vm.clearValidationMessage(index, 'amountToBeBilled')
        }
      },
      model: {
        value: (item.amountToBeBilled),
        callback: function($$v) {
          _vm.$set(item, "amountToBeBilled", $$v)
        },
        expression: "item.amountToBeBilled"
      }
    }) : _c('span', {
      staticClass: "text-muted"
    }, [_vm._v("-")]), _vm._v(" "), (_vm.getFieldValidationMessage(index, 'amountToBeBilled')) ? _c('div', {
      staticClass: "text-danger small mt-1"
    }, [_c('i', {
      staticClass: "fa fa-exclamation-triangle mr-1"
    }), _vm._v("\n                    " + _vm._s(_vm.getFieldValidationMessage(index, 'amountToBeBilled')) + "\n                  ")]) : _vm._e()], 1)]), _vm._v(" "), _c('td', [_c('div', [(item.billToShipper === 'Yes') ? _c('model-list-select', {
      staticStyle: {
        "min-width": "140px"
      },
      attrs: {
        "list": _vm.billToOptions,
        "option-value": "value",
        "option-text": "text",
        "placeholder": "Select"
      },
      model: {
        value: (item.billToType),
        callback: function($$v) {
          _vm.$set(item, "billToType", $$v)
        },
        expression: "item.billToType"
      }
    }) : _c('span', {
      staticClass: "text-muted"
    }, [_vm._v("-")]), _vm._v(" "), (_vm.getFieldValidationMessage(index, 'billToShipper')) ? _c('div', {
      staticClass: "text-danger small mt-1"
    }, [_c('i', {
      staticClass: "fa fa-exclamation-triangle mr-1"
    }), _vm._v("\n                    " + _vm._s(_vm.getFieldValidationMessage(index, 'billToType')) + "\n                  ")]) : _vm._e()], 1)]), _vm._v(" "), _c('td', {
      staticClass: "text-center"
    }, [(item.isCustom) ? _c('b-button', {
      attrs: {
        "variant": "outline-danger",
        "size": "sm"
      },
      on: {
        "click": function($event) {
          _vm.removeRow(index)
        }
      }
    }, [_c('md-icon', [_vm._v("delete")])], 1) : _vm._e()], 1)])
  }))]) : (_vm.natureOfExpense && _vm.natureOfExpense.length === 0) ? _c('div', {
    staticClass: "text-center p-4"
  }, [_c('p', {
    staticClass: "text-muted"
  }, [_vm._v("No expenses added yet.")])]) : _c('div', {
    staticClass: "text-center p-4"
  }, [_c('b-spinner', {
    staticClass: "mr-2",
    attrs: {
      "small": ""
    }
  }), _vm._v("\n          Loading expense options...\n        ")], 1)]), _vm._v(" "), (_vm.natureOfExpense && _vm.natureOfExpense.length > 0) ? _c('div', {
    staticClass: "mt-3"
  }, [_c('small', {
    staticClass: "text-muted"
  }, [_vm._v("\n          Total Expenses: " + _vm._s(_vm.natureOfExpense.length) + " |\n          Total Amount to Pay: $" + _vm._s(_vm.totalAmountToPay.toFixed(2)) + " |\n          Total Amount to Bill: $" + _vm._s(_vm.totalAmountToBill.toFixed(2)) + "\n        ")])]) : _vm._e(), _vm._v(" "), (_vm.showDebug) ? _c('div', {
    staticClass: "mt-4"
  }, [_c('h6', [_vm._v("Debug Info:")]), _vm._v(" "), _c('pre', [_vm._v(_vm._s(JSON.stringify(_vm.natureOfExpense, null, 2)))])]) : _vm._e()])], 1), _vm._v(" "), _c('md-dialog-confirm', {
    ref: "addPop",
    attrs: {
      "md-content-html": _vm.alert.content || ' ',
      "md-ok-text": _vm.alert.ok
    }
  })], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-43584dbd","hasScoped":true}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/component/common/expenseTableComponent.vue
// module id = 2564
// module chunks = 0